import dataLayer from './get_data_layer';

const getProp = (obj, path) =>
  path.split('.').reduce((acc, prop) => acc && acc[prop], obj);

const get = (path) => getProp(dataLayer.get(), path);

export default get;
